<template>
  <div class="box">
    <v-head :title="title"></v-head>
    <div class="content">
      <van-steps active-color="#228ccd" :active="active" style="margin-top:20px">
        <van-step>账号信息</van-step>
        <van-step>设置新密码</van-step>
        <van-step>完成</van-step>
      </van-steps>
      <div class="step-content">
        <step-base @success="success" v-if="active === 0"></step-base>
        <step-new  @success="active=2" v-else-if="active === 1"></step-new>
        <step-successed v-else></step-successed>
      </div>
      <!-- <p class="login-box">
        已有账号，
        <span @click="go('login')">立即登录</span>
      </p> -->
    </div>
  </div>
</template>

<script>
import vHead from "../../components/Subhead.vue";
import { Step, Steps } from "vant";
import stepBase from "./base";
import stepNew from "./newPW";
import stepSuccessed from "./successed";

export default {
  data() {
    return {
      active: 0,
      title:"忘记密码"
    };
  },
  components: {
    vHead,
    [Step.name]: Step,
    [Steps.name]: Steps,
    stepBase,
    stepNew,
    stepSuccessed
  },
  methods: {
    go(pathName) {
      this.$router.push({ name: pathName });
    },
     success(mobile) {
      this.active = 1;
      this.mobile = mobile;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  padding: 36px 25px;
}
/deep/.van-step--horizontal .van-step__title{ font-size:16px}
.step-content{ margin-top: 40px;}
</style>
